import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const BRAND = {
  name: "Abundant Life No. 2",
  subname: "The Surrender Church",
  pastor: "Pastor Shalonda Raymond",
  city: "Brunswick, Georgia",
  email: "thesurrenderedplace1@gmail.com",
  phone: "(904) 348-0337",
  zelle: "404-668-4138",
  cashapp: "$BOSSCONNECT",
  youtube: "https://www.youtube.com/@Thesurrendered1",
  facebook: "https://www.facebook.com/profile.php?id=61563109180701",
  tiktok: "https://www.tiktok.com/@pastorshalonda",
  instagram: "https://www.instagram.com/thesurrenderedplace",
  logoChurch: "https://customer-assets.emergentagent.com/job_pastor-shalonda/artifacts/29jh2m1x_1DC05B12-3BA4-4FD5-BCF7-25A187829C95.PNG",
  logoBlueprint: "https://customer-assets.emergentagent.com/job_pastor-shalonda/artifacts/kbj365z4_D4AB0A4F-21DD-482E-B92F-58493054D520.PNG",
  pastorPhoto: "https://customer-assets.emergentagent.com/job_pastor-shalonda/artifacts/tbaf2iue_9A029C13-A83B-4007-94AC-0A1438327A9D.PNG",
  homePhoto: "https://customer-assets-eiarnc6j.emergentagent.net/job_pastor-shalonda/artifacts/b0700c21bac450f1_Elegant%20Executive%20Office%20Headshot.png",
  taglines: [
    "Where Surrender Meets Transformation",
    "Your Next Step Starts Here",
    "Break Cycles. Gain Clarity. Move Forward with God.",
    "Healing. Growth. Purpose.",
  ],
};
